<button class="seal-link navbar-brand">
  <img src="assets/img/seal-and-title-white.svg" class="seal-and-title mr-2" alt="FEC Seal" height="48" width="227" />
</button>
<div class="cookies-disabled-message">
  <img src="assets/img/exclamation.svg" height="36px" width="36px" alt="exclamation" />
  <div class="text-container">
    <h1>Cookies are disabled in your browser</h1>
    <p>
      Your cookie settings are preventing you from using FECfile+. To continue, cookies must be enabled in your browser.
    </p>
    <hr />
    <p>Try these steps to enable cookies in your browser:</p>
    <ul>
      <li>Open your browser's settings or preferences</li>
      <li>Search browser settings for "cookies"</li>
      <li>Or, search online for "Enable cookies in my browser."</li>
    </ul>
    <p>Once cookies are enabled, refresh this page and try again.</p>
  </div>
</div>
